var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-header",class:"layout-header_en"},[_c('div',{staticClass:"layout-nav-header"},[_c('div',{staticClass:"layout-nav-header-main"},[_c('div',{staticClass:"layout-nav-header-left"},[_c('layout-logo')],1),_vm._v(" "),_c('div',{staticClass:"layout-nav-header-menu"},[_c('LayoutMenu',{attrs:{"menus":_vm.headerMenuConfig,"mode":"horizontal"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24d2e226","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/HeaderLayout/components/NavBar.vue
// module id = null
// module chunks = 